import { chain } from "underscore";
import Program from "src/resources/programs/models/Program";
const toProgram = (campaignSummaries, programLabel) => {
    return new Program({
        program_label: programLabel,
        campaigns: campaignSummaries,
    });
};
export const transforms = {
    toPrograms: (campaignSummaries) => {
        const programs = chain(campaignSummaries)
            .groupBy((campaign) => campaign.program_label)
            .map(toProgram)
            .value();
        return programs;
    },
};
